import { Config } from '@/bootstrap/config';
import { Vegsystemreferanse } from '@/domain/omrader';
import { Vegobjekt } from '@/domain/vegobjekter/Vegobjekt';

export function getRoadReferenceFiksURL(
    reference: Vegsystemreferanse,
    config: Config
): string {
    return `${config.fiksvegdata_url}?vegsystemreferanse=${reference.kortform}`;
}

export function getVegObjektFiksURL(vegobjekt: Vegobjekt, config: Config): string {
    return `${config.fiksvegdata_url}?vegobjekt=${vegobjekt?.id}&vegsystemreferanse=${vegobjekt?.lokasjon?.vegsystemreferanser}`;
}
